import React from "react";
import { MapPin, Phone, Building2 } from "lucide-react";

const Location = () => {
  const locations = [
    {
      city: "Pathankot",
      name: "Grand Cinemaz",
      address: "City Centre Mall, Dalhousie Road, Pathankot, Punjab",
      pincode: "145001",
      phone: "9056805305",
    },
    {
      city: "Ghaziabad",
      name: "Grand Cinemaz",
      address: "Nehru Nagar, D'Mart, Ghaziabad, Uttar Pradesh",
      pincode: "201001",
      phone: "8448619955",
    },
    {
      city: "Saharanpur",
      name: "Grand Cinemaz",
      address: "Old Kalapna Cinema Patel Nagar Ambala road Saharanpur, Uttar Pradesh" ,
      pincode: "247001",
      phone: "7452002610",
    },
    {
      city: "Una",
      name: "Grand Cinemaz",
      address: "The Gulmohar Grand, Una, Himachal Pardesh",
      pincode: "174306",
      phone: "6230301476",
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-red-950 to-blue-950 py-16 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-amber-200 via-yellow-300 to-amber-200 mb-4">
            Our Locations
          </h1>
          <div className="w-32 h-1 bg-gradient-to-r from-transparent via-amber-400 to-transparent mx-auto mb-6"></div>
          <p className="text-gray-300 text-lg max-w-2xl mx-auto">
            Experience luxury cinema at our premium locations across the region
          </p>
        </div>

        {/* Location Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
          {locations.map((location, index) => {
            const mapQuery = `${location.name}, ${location.address}, ${location.city}, ${location.pincode}`;
            const mapUrl = `https://www.google.com/maps?q=${encodeURIComponent(
              mapQuery
            )}&output=embed`;
            const mapLink = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
              mapQuery
            )}`;

            return (
              <div
                key={index}
                className="group relative bg-gradient-to-br from-slate-800/50 to-slate-900/50 backdrop-blur-sm rounded-2xl overflow-hidden border border-amber-500/20 hover:border-amber-400/50 transition-all duration-500 hover:shadow-2xl hover:shadow-amber-500/20 hover:-translate-y-2"
              >
                {/* Decorative gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-br from-amber-500/0 via-amber-500/0 to-amber-500/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

                {/* City badge */}
                <div className="absolute top-0 right-0 bg-gradient-to-br from-amber-500 to-amber-600 text-white px-6 py-2 rounded-bl-2xl font-semibold text-sm tracking-wider shadow-lg">
                  {location.city.toUpperCase()}
                </div>

                <div className="relative p-8 pt-12">
                  {/* Cinema name */}
                  <div className="mb-6">
                    <div className="flex items-center gap-2 mb-2">
                      <Building2 className="w-6 h-6 text-amber-400" />
                      <h2 className="text-2xl font-bold text-white">
                        {location.name}
                      </h2>
                    </div>
                  </div>

                  {/* Divider */}
                  <div className="w-full h-px bg-gradient-to-r from-transparent via-amber-500/30 to-transparent mb-6"></div>

                  {/* Address (Clickable) */}
                  <div
                    onClick={() => window.open(mapLink, "_blank")}
                    className="flex gap-3 mb-6 cursor-pointer hover:bg-slate-800/30 rounded-xl p-3 transition-colors"
                  >
                    <MapPin className="w-5 h-5 text-amber-400 flex-shrink-0 mt-1" />
                    <div>
                      <p className="text-gray-300 leading-relaxed hover:text-amber-200 transition-colors">
                        {location.address}
                      </p>
                      <p className="text-amber-200 font-medium mt-1">
                        PIN: {location.pincode}
                      </p>
                    </div>
                  </div>

                  {/* Embedded Google Map */}
                  <div className="rounded-xl overflow-hidden mb-6 border border-amber-500/10 shadow-md">
                    <iframe
                      src={mapUrl}
                      loading="lazy"
                      allowFullScreen
                      referrerPolicy="no-referrer-when-downgrade"
                      className="w-full h-40"
                      title={`Map of ${location.city}`}
                    ></iframe>
                  </div>

                  {/* Phone */}
                  <div className="flex items-center gap-3 bg-slate-800/50 rounded-xl p-4 border border-amber-500/10">
                    <Phone className="w-5 h-5 text-amber-400" />
                    <a
                      href={`tel:${location.phone}`}
                      className="text-white font-semibold hover:text-amber-300 transition-colors"
                    >
                      {location.phone}
                    </a>
                  </div>

                  {/* Decorative corner accent */}
                  <div className="absolute bottom-0 left-0 w-20 h-20 bg-gradient-to-tr from-amber-500/10 to-transparent rounded-tr-full"></div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Footer text */}
        <div className="text-center mt-16">
          <p className="text-gray-400 italic">
            Visit us today and immerse yourself in the ultimate cinema
            experience
          </p>
        </div>
      </div>
    </div>
  );
};

export default Location;
